import {ampVehicleWeightTypes} from '@ace-de/eua-entity-types';

const getVehicleWeightType = vehicleWeight => {
    let weightType;

    switch (true) {
        case (vehicleWeight <= ampVehicleWeightTypes.LIGHT_WEIGHT_VEHICLE): {
            weightType = ampVehicleWeightTypes.LIGHT_WEIGHT_VEHICLE;
            break;
        }
        case (vehicleWeight <= ampVehicleWeightTypes.MEDIUM_WEIGHT_VEHICLE): {
            weightType = ampVehicleWeightTypes.MEDIUM_WEIGHT_VEHICLE;
            break;
        }
        default:
            weightType = ampVehicleWeightTypes.HEAVY_WEIGHT_VEHICLE;
    }

    return weightType;
};

export default getVehicleWeightType;
